import { TiptapContentResolver } from "./../../toolbars-v3/ContentResolver.js";
const getNodeLinkData = TiptapContentResolver.create((_, __, editor) => {
  const node = editor?.state?.selection?.node;
  if (node) {
    return node.attrs?.link;
  } else {
    return void 0;
  }
});
export {
  getNodeLinkData
};
//# sourceMappingURL=get-node-link-data.js.map
